function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, Messaging, controllerMixin } from 'oskari-ui/util';
import { showViewForm } from '../view/ViewForm/ViewForm';
var ViewsHandler = /*#__PURE__*/function (_StateHandler) {
  function ViewsHandler(instance) {
    var _this;
    _classCallCheck(this, ViewsHandler);
    _this = _callSuper(this, ViewsHandler);
    _this.instance = instance;
    _this.sandbox = Oskari.getSandbox();
    _this.setState({
      data: [],
      loading: false
    });
    _this.popupControls = null;
    _this.loc = Oskari.getMsg.bind(null, 'MyData');
    _this.viewService = _this.instance.getViewService();
    _this.eventHandlers = _this.createEventHandlers();
    _this.registerTool();
    _this.refreshViewsList();
    return _this;
  }
  _inherits(ViewsHandler, _StateHandler);
  return _createClass(ViewsHandler, [{
    key: "getName",
    value: function getName() {
      return 'MyViewsHandler';
    }
  }, {
    key: "popupCleanup",
    value: function popupCleanup() {
      if (this.popupControls) this.popupControls.close();
      this.popupControls = null;
    }
  }, {
    key: "showErrorMessage",
    value: function showErrorMessage(message) {
      var dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
      var button = dialog.createCloseButton(this.loc('tabs.myviews.button.ok'));
      button.addClass('primary');
      dialog.show(this.loc('tabs.myviews.error.title'), message, [button]);
    }
  }, {
    key: "promptForView",
    value: function promptForView(view) {
      var _this2 = this;
      var _ref = view || {},
        id = _ref.id;
      if (this.popupControls) {
        if (this.popupControls.id === id) {
          this.popupControls.bringToTop();
          return;
        }
        this.popupCleanup();
      }
      var editCb = function editCb(success) {
        return _this2.handleSaveViewResponse(success);
      };
      var onSave = function onSave(values) {
        _this2.updateState({
          loading: true
        });
        _this2.sandbox.postRequestByName('StateHandler.SaveStateRequest', [values.name, values.description, values.isDefault]);
      };
      var onEdit = function onEdit(values) {
        _this2.updateState({
          loading: true
        });
        _this2.viewService.updateView(id, values.name, values.description, values.isDefault, editCb);
      };
      var onOk = id ? onEdit : onSave;
      // create popup
      this.popupControls = showViewForm(view, onOk, function () {
        return _this2.popupCleanup();
      });
    }
  }, {
    key: "handleSaveViewResponse",
    value: function handleSaveViewResponse(isSuccess) {
      if (isSuccess) {
        Messaging.success(this.loc('tabs.myviews.save.success'));
        this.refreshViewsList();
      } else {
        Messaging.error(this.loc('tabs.myviews.error.notsaved'));
        this.updateState({
          loading: false
        });
      }
      this.popupCleanup();
    }
  }, {
    key: "refreshViewsList",
    value: function refreshViewsList() {
      var _this3 = this;
      this.updateState({
        loading: true
      });
      this.viewService.loadViews('USER', function (isSuccess, response) {
        if (isSuccess) {
          var views = response.views;
          views.forEach(function (view) {
            view.name = Oskari.util.sanitize(view.name);
            view.description = Oskari.util.sanitize(view.description);
          });
          _this3.updateState({
            data: views,
            loading: false
          });
        } else {
          _this3.showErrorMessage(_this3.loc('tabs.myviews.error.loadfailed'));
          _this3.updateState({
            loading: false
          });
        }
      });
    }
  }, {
    key: "registerTool",
    value: function registerTool() {
      var _this4 = this;
      if (!Oskari.requestBuilder('StateHandler.SaveStateRequest')) {
        return;
      }
      var loggedIn = Oskari.user().isLoggedIn();
      var tool = {
        iconCls: 'tool-save-view',
        sticky: false,
        disabled: !loggedIn,
        tooltip: this.loc('tabs.myviews.button.toolbarsave'),
        prepend: true,
        callback: function callback() {
          if (loggedIn) {
            _this4.promptForView();
          }
        }
      };
      this.sandbox.postRequestByName('Toolbar.AddToolButtonRequest', ['save_view', 'viewtools', tool]);
    }
  }, {
    key: "deleteView",
    value: function deleteView(view) {
      var _this5 = this;
      this.updateState({
        loading: true
      });
      this.viewService.deleteView(view, function (isSuccess) {
        if (isSuccess) {
          if (Oskari.app.getUuid() === view.uuid) {
            // Deleting the current map view. Load default view but don't lose user's layers.
            window.location.href = _this5.getDefaultViewUrlWithCurrentMapParams(view.srsName);
          } else {
            _this5.refreshViewsList();
          }
        } else {
          _this5.showErrorMessage(Oskari.getMsg('MyData', 'tabs.myviews.error.notdeleted'));
          _this5.updateState({
            loading: false
          });
        }
      });
    }
  }, {
    key: "editView",
    value: function editView(data) {
      this.promptForView(data);
    }
  }, {
    key: "setDefaultView",
    value: function setDefaultView(data) {
      var _this6 = this;
      this.updateState({
        loading: true
      });
      this.viewService.updateView(data.id, data.name, data.description, !data.isDefault, function (isSuccess) {
        _this6.handleSaveViewResponse(isSuccess);
      });
    }
  }, {
    key: "openView",
    value: function openView(data) {
      if (data.srsName !== this.sandbox.getMap().getSrsName()) {
        window.location.href = data.url;
        return;
      }
      var rb = Oskari.requestBuilder('StateHandler.SetStateRequest');
      if (rb) {
        var req = rb(data.state);
        req.setCurrentViewId(data.id);
        this.sandbox.request(this.instance, req);
      }
    }
  }, {
    key: "saveCurrent",
    value: function saveCurrent() {
      this.promptForView();
    }
  }, {
    key: "getDefaultViewUrlWithCurrentMapParams",
    value: function getDefaultViewUrlWithCurrentMapParams(srsName) {
      var systemDefault = Oskari.app.getSystemDefaultViews().find(function (defaultView) {
        return defaultView.srsName === srsName;
      });
      var url = this.sandbox.createURL('/?', true);
      if (systemDefault) {
        // use uuid if available so server doesn't need to provide the global default
        url += 'uuid=' + systemDefault.uuid + '&';
      }
      url += this.sandbox.generateMapLinkParameters();
      return url;
    }
  }, {
    key: "createEventHandlers",
    value: function createEventHandlers() {
      var _this7 = this;
      var handlers = {
        'StateSavedEvent': function StateSavedEvent(event) {
          _this7.handleSaveViewResponse(!event.isError());
        }
      };
      Object.getOwnPropertyNames(handlers).forEach(function (p) {
        return _this7.sandbox.registerForEventByName(_this7, p);
      });
      return handlers;
    }
  }, {
    key: "onEvent",
    value: function onEvent(e) {
      var handler = this.eventHandlers[e.getName()];
      if (!handler) {
        return;
      }
      return handler.apply(this, [e]);
    }
  }]);
}(StateHandler);
var wrapped = controllerMixin(ViewsHandler, ['deleteView', 'editView', 'setDefaultView', 'openView', 'saveCurrent']);
export { wrapped as MyViewsHandler };